<template>
    <div class="upload h-full">
        <h1>摘要生成</h1>

        <div class="tabs flex w-[800px] mb-[10px]">
            <div class="tab mr-10 font-bold cursor-pointer" :class="[type == 'text' ? 'text-[#4C5BDF]' : 'text-[#B0B0B1]']" @click="type = 'text'">添加内容描述</div>
            <div class="tab mr-10 font-bold cursor-pointer" :class="[type == 'file' ? 'text-[#4C5BDF]' : 'text-[#B0B0B1]']" @click="type = 'file'">基于文件生成</div>
        </div>
        <div class="add-des" v-if="type == 'text'">
            <textarea
                class="des_textarea h-[160px]"
                placeholder="请输入内容描述"></textarea>
        </div>
        <div v-if="type == 'file'">
            <div class="upload-box">
                <!--上传-->
                <el-upload
                    v-if="!loading"
                    class="upload-demo"
                    ref="uploadBox"
                    :width="798"
                    :height="318"
                    drag
                    :limit="1"
                    :before-upload="uploadFile"
                    accept=".pdf,.doc,.docx"
                    action=""
                    :disabled="fileList.length > 0"
                    >
                    <template v-if="fileList.length == 0">
                        <div class="el-icon-upload upload-icon"></div>
                        <div class="el-upload__text">点击或拖拽文件到此处上传</div>
                        <div class="el-upload__tip" slot="tip">
                            <p>格式：PDF、Word文档</p>
                            <p>大小：单个文档小于10M</p>
                        </div>
                    </template>

                    <!--上传成功-->
                    <div v-else class="upload-success">
                        <div class="success-title">
                            <span class="success-icon"></span>上传成功
                        </div>
                        <div class="upload-list" v-for="item in fileList" :key="item.name">
                            <div class="one-file" :class="{'pdf-file':item.type == 'application/pdf'}">{{item.name}}</div>
                        </div>
                        <div class="re-upload">
                            <button @click.stop="{fileList = []; $refs.uploadBox.clearFiles()}">重新上传</button>
                        </div>
                    </div>
                </el-upload>
                
                <!--加载中-->
                <div class="loading-box" v-if="loading">
                    <img src="@/assets/loading.gif" />
                </div>
            </div>
        </div>

        <el-button
            class="read-now-btn"
            type="primary"
            :disabled="fileList.length == 0"
            @click="readAbstractBtn"
        >
            立即生成
        </el-button>
    </div>
</template>

<script>
export default {
    // emits: ['getPDFRead'],
    data() {
        return {
            fileList: [],
            loading: false,
            type:'text',    // text | file

            
        };
    },

    methods: {
        uploadFile(file){
            let fileType = file.name.split('.').pop()
            if(fileType != 'pdf' && fileType != 'doc' && fileType != 'docx'){
                this.$message.error('文件格式错误,请上传PDF、Word文档');
                return false
            }
            console.log(file);
            this.fileList.push(file);
            return false
        },
        async readAbstractBtn(){
            this.loading = true;
            const file = this.fileList[0]
            console.log(file);

            // const formData = new FormData();
            // formData.append('file', file);
            // formData.append('token', window.localStorage.getItem("token"));

            // this.fileList[0].append('token', window.localStorage.getItem("token"))
            // let params = {
            //     token: window.localStorage.getItem("token"),
            //     file: this.fileList[0]
            // };
            // console.log(params);
            // const {data} = await this.$api.getPDFRead(params)
            // console.log(data)
            // this.loading = false;
            // this.$emit('upload-result', data);

        },
    },
}
</script>

<style lang="scss" scoped>
.upload{
    @apply flex flex-col items-center justify-center h-full;
    h1{
        @apply text-[22px] text-[#4C5BDF] leading-8 font-bold;
    }
    h2{
        @apply text-sm text-[#444444] font-bold;
    }
    .add-des{
        // @apply mt-8;
        .des_textarea{
            @apply w-[800px] h-[160px] mt-2 mb-[30px] p-4 bg-white rounded-[15px] border border-dashed border-[#C2C4CB] overflow-hidden resize-none outline-none;
        }
    }
    .upload-box{
        @apply w-[800px] h-[300px] mt-2 mb-6 bg-white rounded-[15px] border border-dashed border-[#C2C4CB] overflow-hidden;
        .upload-demo{
            @apply flex flex-col items-center justify-center w-full h-full relative;
            ::v-deep .el-upload{
                @apply w-full h-full;
            }
            ::v-deep .el-upload-dragger{
                @apply w-full h-full border-none bg-transparent;
                .upload-icon{
                    background: url('@/assets/icon_upload.png') no-repeat center;
                    background-size: 37px 37px;
                    @apply w-[37px] h-[37px] mt-[71px] mb-[18px];
                    
                    &::before{
                        content: '';
                    }
                }
                .el-upload__text{
                    @apply text-lg text-[#444444] font-bold;
                }
            }
            
            .el-upload__tip{
                @apply absolute top-[164px] left-[50%] -translate-x-2/4 pointer-events-none;
            }
        }

        .upload-success{
            @apply flex flex-col items-center justify-between w-full h-full px-5 pb-5;
            .success-title{
                @apply flex items-center text-lg text-[#444444] leading-[25px] font-bold mt-[71px] mb-10;
                .success-icon{
                    background: url('@/assets/icon_success.png') no-repeat center;
                    background-size: 37px 37px;
                    @apply w-[37px] h-[37px] mr-[14px];
                }
            }
            .upload-list{
                @apply flex flex-row items-center justify-center;
                .one-file{
                    @apply text-sm leading-[22px] text-[#333333] pl-[28.5px];
                    background: url('@/assets/word_icon.png') no-repeat left top;
                    background-size: 20px 22px;
                    &.pdf-file{
                        background: url('@/assets/pdf_icon.png') no-repeat left top;
                        background-size: 20px 22px;
                    }
                }
            }
            .re-upload{
                @apply flex-1 flex items-end justify-end w-full text-sm text-[#E42D2D] font-bold;
            }
        }

        .loading-box{
            @apply w-full h-full flex flex-col items-center justify-center w-full;
            img{
                width: 10%;
            }
        }
    }
    ::v-deep .read-now-btn.el-button--primary{
        background: #4C5BDF !important;
        color: white !important;
        border: none !important;
        @apply w-[200px] h-[46px] bg-[#4C5BDF] text-[16px] rounded-[10px];
    }
    ::v-deep .read-now-btn.is-disabled{
        background: #ACB2F2 !important;
    }
}
</style>